<template>

  <div class="currentExercise">
    <div class="exercise-item text-left">
      <span class="time" v-if="examResults">
       <span v-if="CelotnoVprasanje.correct != null && CelotnoVprasanje.correct !== 0">
          <i v-if="CelotnoVprasanje.correct" class="fa fa-check"></i>
          <i v-else class="fa fa-times"></i>
        </span>
      </span>
      <span class="time" v-else>
        <span v-if="isCorrect != null" class="green-color">
          {{$t('pages.exercise.submitEssay')}}
        </span>
      </span>

      <h4 class="exercise-header" v-html="this.$options.filters.pickTranslation(CelotnoVprasanje.text)"></h4>
      <div class="exercise-body text-left">
        <span class="row">
          <textarea v-if="examResults" disabled v-model="submitInfo.selectedAnswer" class="form-control" :class="[CelotnoVprasanje.correct === true ? 'correct' : '', CelotnoVprasanje.correct === false ? 'incorrect' : '']" rows="3" id="comment"></textarea>
          <textarea v-else @keyup.enter="evalExercise" v-model="submitInfo.selectedAnswer" class="form-control" rows="3" id="comment"></textarea>
        </span>
      </div>
      <div class="exercise-footer">
        <template v-if="isExam">
          <button v-if="!examResults" @click.prevent="evalExercise" type="submit" class="btn btn-success pull-left" :class="{'small-button':detectMobile() && scoringSettings && scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum}">{{$t('pages.exercise.evaluateExam')}}</button>
          <button v-if="!examResults" @click.prevent="clearExercise" type="submit" class="btn btn-warning pull-left" :class="{'small-button':detectMobile() && scoringSettings && scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum}">{{($t('pages.exercise.examClearExercise'))}}</button>
          <!-- Resitve -->
          <ShowSolutionExamResults :examResults="examResults" :CelotnoVprasanje="CelotnoVprasanje" :nameOfTheParent="Name" v-if="examResults"/>
          <!-- Gumb za prikaz detaljnih resitvi -->
          <SolutionModal :CelotnoVprasanje="CelotnoVprasanje" :solutionKeyId="solutionKey" :i="index" :identifier="identifier" :exerciseVersionId="exerciseVersionId" :parentIdentifier="parent" v-if="examResults"/>
          <!--Tocke-->
          <div class="pull-right" style="margin-top: 14px" v-if="!examResults">
            <span v-if="scoringSettings" class="text-muted">{{$t('pages.exercise.points')}}: {{scoringSettings[CelotnoVprasanje.guid].posPoints}}
              <span v-if="scoringSettings[CelotnoVprasanje.guid].allowNegativePointsSum">{{$t('pages.exercise.points')}}: (-{{scoringSettings[CelotnoVprasanje.guid].negPoints}})</span>
            </span>
          </div>
          <div class="pull-right" style="margin-top: 14px" v-else-if="CelotnoVprasanje.points !== null && CelotnoVprasanje.maxPoints !== null">
            <span class="text-muted">{{$t('pages.exercise.points')}}: {{CelotnoVprasanje.points}}/{{CelotnoVprasanje.maxPoints}}
            </span>
          </div>
          <div class="pull-right" style="margin-top: 14px" v-else>
            <span class="text-muted">{{$t('pages.exercise.pointsNotAvailable')}}</span>
          </div>
          <div class="vertical">
            <transition name="fade">
              <p class="text-green" v-if="submitted">{{$t('pages.exercise.evaluated')}}</p>
            </transition>
          </div>
        </template>
        <template v-else>
          <button @click.prevent="evalExercise" type="submit" class="btn btn-success pull-left" :class="{'small-button':detectMobile() && CelotnoVprasanje.hasSolution}">{{($t('pages.exercise.evaluateEssay'))}}</button>
          <button @click.prevent="hintExercise" v-if="CelotnoVprasanje.hintCount > 0" type="submit" class="btn btn-warning text-center" :class="{'small-button':detectMobile() && CelotnoVprasanje.hasSolution}">{{$t('pages.exercise.hintText')}}</button>
          <!-- Gumb in modal za prikaz detaljne resitve -->
          <SolutionModal :CelotnoVprasanje="CelotnoVprasanje" :solutionKeyId="solutionKey" :i="index" :identifier="identifier" :exerciseVersionId="exerciseVersionId" :parentIdentifier="parent"/>
          <!--<button v-if="CelotnoVprasanje.hasSolution" @click.prevent="showSolution" type="submit" class="btn btn-primary pull-right" :class="{'small-button':detectMobile() && CelotnoVprasanje.hasSolution}">{{$t('pages.exercise.solvedText')}}</button>-->
        </template>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- HINT AND SOLUTION MODAL -->
    <div class="modal modal-default fade" :id="hintKey" v-if="submitInfo.hintNumber > 0">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exercise.hintText')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div v-for="(eHint, index) in exHints" :key="index">
                <div v-html="translateVhtml(eHint)"></div>
              </div>
            </div>
          </div>
        </div>
      <!-- /.modal-content -->
      </div>
    <!-- /.modal-dialog -->
    </div>
    <!--
    <div class="modal modal-default fade" :id="solutionKey" v-if="doShowSolution">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exercise.solvedText')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div v-html="translateVhtml(exSolutions)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- HINT AND SOLUTION MODAL -->
  </div>

</template>

<script>
import exerciseEvaluation from '@/components/mixins/ExerciseEvaluation.vue'
import ShowSolutionExamResults from '@/components/exercises/ShowSolutionExamResults.vue'
import SolutionModal from '@/components/exercises/SolutionModal.vue'
export default {
  name: 'essay',
  components: {
    ShowSolutionExamResults,
    SolutionModal
  },
  data () {
    return {
      Name: 'essay'
    }
  },
  computed: {
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin'
    }
  },
  props: ['scoringSettings', 'parent', 'index', 'identifier', 'exerciseVersionId'],
  methods: {
    detectMobile () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    clearFields () {
    }
  },
  mounted () {
    if (this.examResults) {
      this.submitInfo.selectedAnswer = this.CelotnoVprasanje.answer
    }
  },
  mixins: [exerciseEvaluation]
}
</script>

<style scoped>
.center {
    margin: auto;
    width: 50%;
    border: 3px solid green;
    padding: 10px;
}
textarea {
    resize: none;
}
.green-color {
  color: green;
}
.fa-check {
  color: green;
}
.fa-times {
  color: red
}
.exercise-body, .exercise-item {
  padding-left: 1ex;
}
.small-button{
  padding-left: 1em !important;
  padding-right: 1em !important;
}
</style>



// WEBPACK FOOTER //
// Essay.vue?29a54c76